module.exports = __webpack_public_path__ + "img/sales-dashboard.8574eb26.png";